'use client';

import { PlusIcon } from '@/icons';
import { useRef } from 'react';
import { HoverableIcon } from './terminal/HoverableIcon';

export const UploadButton = ({
  onUpload,
  fileType,
  activeButton,
  setActiveButton,
}: {
  onUpload: (file: File) => void;
  fileType: string;
  activeButton: string | null;
  setActiveButton: (value: string | null) => void;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onUpload(file);
    }
    event.target.value = '';
  };

  return (
    <div>
      <input ref={fileInputRef} type="file" accept={`${fileType}/*`} onChange={handleFileChange} className="hidden" />
      <HoverableIcon
        icon={
          <div
            role="button"
            onClick={handleClick}
            className="cursor-pointer flex w-5 h-5 items-center justify-center rounded-full border border-grey-300 hover:border-white"
          >
            <PlusIcon className="w-3 h-3" />
          </div>
        }
        label="Upload images"
        isActive={activeButton === 'upload'}
        onMouseEnter={() => setActiveButton('upload')}
        onMouseLeave={() => setActiveButton(null)}
      />
    </div>
  );
};
